const setLoginModal = (open) => {
  return { type: "SET_LOGIN_MODAL", open: open };
};
const setConfirmPhoneModal = () => {
  return { type: "SET_CONFIRM_PHONE_MODAL", open: true };
};
const setConfirmEmailModal = () => {
  return { type: "SET_CONFIRM_EMAIL_MODAL", open: true };
};
const setNoMoneyModal = () => {
  return { type: "SET_NO_MONEY_MODAL", open: true };
};
const setCheckSettingsModal = () => {
  return { type: "SET_CHECK_SETTINGS_MODAL", open: true };
};
const noModal = () => {
  return { type: "NO_MODAL" };
};
const setTestQuestionTextExplanation = () => {
  return { type: "SET_TEST_QUESTION_TEXT_EXPLANATION_MODAL", open: true };
};
const setTestQuestionVideoExplanation = () => {
  return { type: "SET_TEST_QUESTION_VIDEO_EXPLANATION_MODAL", open: true };
};

const setLanguageModal = () => {
  return { type: "SET_LANGUAGE_MODAL", open: true };
};

const setConfirmLanguageModal = () => {
  return { type: "SET_CONFIRM_LANGUAGE_MODAL", open: true };
};
const setNotificationModal = () => {
  return { type: "SET_NOTIFICATION_MODAL", open: true };
};
const setPaymentServiceSelectModal = () => {
  return { type: "SET_PAYMENT_SERVICE_SELECT_MODAL", open: true };
};

export {
  setLoginModal,
  setConfirmPhoneModal,
  setConfirmEmailModal,
  noModal,
  setNoMoneyModal,
  setTestQuestionTextExplanation,
  setTestQuestionVideoExplanation,
  setLanguageModal,
  setConfirmLanguageModal,
  setNotificationModal,
  setPaymentServiceSelectModal,
  setCheckSettingsModal
};
